export const envIsProd = () => {
  // split this out into two parts, as the web apps will always have NODE_ENV of 'production' regardless of the backend env it's connected to.
  if (typeof window !== 'undefined') {
    const monzoEnv = window.Monzo.env.env
    if (monzoEnv != null) return monzoEnv === 'prod'
  }

  // our next.js apps don't have a monzoEnv so we still need to check for NODE_ENV.
  if (typeof process !== 'undefined') {
    const processEnv = process.env.NODE_ENV
    return processEnv != null && processEnv === 'production'
  }

  return false
}
